/**
 * DEPENDENCIES
 */

import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';

const depthBodyFixed = [];

class Utils {
    /**
     * Метод устанавливает комфорную задержку выполнения анимации.
     * @return {Number} comfortableAnimationTimeValue - значение в мс.
     */
    static comfortableAnimationTime() {
        const comfortableAnimationTimeValue = 300;

        return comfortableAnimationTimeValue;
    }

    /**
     * Метод полностью очищает весь html элемент.
     * @param {Object} element - DOM-элемент, который необходимо очистить.
     */
    static clearHtml(element) {
        element.innerHTML = '';
    }

    /**
     * Метод вставляет содержимое в блок.
     * @param {Object} element - элемент в который нужно вставить.
     * @param {Object/string} content - вставляемый контент.
     */
    static insetContent(element, content) {
        if (typeof content === 'string') {
            element.insertAdjacentHTML('beforeend', content);
        } else if (typeof content === 'object') {
            element.appendChild(content);
        }
    }

    /**
     * Метод полностью удаляет элемент из DOM-дерева.
     * @param {Object} element - элемент, который необходимо удалить.
     */
    static removeElement(element) {
        // node.remove() не работает в IE11
        element.parentNode.removeChild(element);
    }


    /**
     * Метод показывает элемент.
     * @param {Node} element - элемент, который необходимо показать.
     * @param {string} type - тип элеменат (block || flex)
     */
    static show(element, type = 'block') {
        element.style.display = type;
    }

    /**
     * Метод скрывает элемент.
     * @param {Node} element - элемент, который необходимо скрыть.
     */
    static hide(element) {
        element.style.display = 'none';
    }

    /**
     * Выбирает окончание слова.
     * @param {Number} n - количество
     * @param {Array} words - масcив слов. Например показать еще ['квартиру', 'квартиры', 'квартир']
     * @return {String} - слово в правильном склонении.
     */
    static pluralWord(n, words) {
        /* eslint-disable  */
        const $i = n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        /* eslint-enable*/

        return words[$i];
    }

    /**
     * Метод отправляет ajax запрос на сервер.
     * @param {Object} data - отправляемые данные.
     * @param {String} url - маршрут по которому нужно произвести запрос.
     * @param {Function} callback -  функция обратного вызова, которая при успехе вызовет success, а при ошибке error.
     * @param {String} method - метод запроса
     */
    static send(data, url, callback = function() {}, method = 'GET') { // eslint-disable-line
        const xhr = new XMLHttpRequest();
        const statusSuccess = 200;
        const dataToSend = data;

        xhr.open(method, url);

        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');

        if (typeof dataToSend === 'object') {
            // dataToSend = $.param(dataToSend);
        }

        xhr.send(dataToSend);

        xhr.onload = function XHR() {
            if (xhr.status === statusSuccess) {
                const req = JSON.parse(this.responseText);

                callback.success(req);
            } else {
                callback.error(xhr.status);
            }
        };
    }

    /**
     * Метод проверяет наличие интернета
     * @return {boolean} - При наличии результатом будет true, а при отсутсвии false.
     */
    static checkInternetConnection() {
        return navigator.onLine;
    }

    /**
     * Метод проверяет присутствует ли ключ в объекте
     * @param {Object} object - проверяем объект
     * @param {String} key - ключ, наличие которого проверяет в объекте
     * @return {boolean} - присутствует или нет ключ в объекте
     */
    static keyExist(object, key) {
        return Object.prototype.hasOwnProperty.call(object, key);
    }

    /**
     * Метод проверяет пустой объект или нет
     * @param {Object} object - объект проверяемый на пустоту
     * @return {boolean} - true если пустой и false если полный
     */
    static isEmptyObject(object) {
        const empty = 0;

        return Object.keys(object).length === empty;
    }

    /**
     * Проверяет переданные данные на строку
     * @param {String} string - данные на проверку
     * @return {boolean} - возращает true, если строка, и false наоборот
     */
    static isString(string) {
        return typeof string === 'string';
    }

    /**
     * Узнает index элемента в родительской элемент
     * Аналог jquery.index()
     * @param {Node} element - искомый элемент
     * @return {number} - порядковый номер (индекс) в родительском элементе
     */
    static getElementIndex(element) {
        return Array.from(element.parentNode.children).indexOf(element);
    }

    /**
     * Проверяет, поддерживает ли устройство touch-события
     * @return {boolean} - возращает true, если Touch-устройство, и false наоборот
     */
    static isTouch() {
        return Boolean(typeof window !== 'undefined' &&
            ('ontouchstart' in window ||
                (window.DocumentTouch &&
                    typeof document !== 'undefined' &&
                    document instanceof window.DocumentTouch))) ||
            Boolean(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
    }

    /**
     * Узнает находится ли элемент во вьюпорте
     * @param {Node} element - искомый элемент
     * @param {Number} belowViewport - оффсет
     * @return {boolean} - возвращает true, если элемент виден на экране, и false наоборот
     */
    static isInViewport(element, belowViewport = 0) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;

        const verticalInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= belowViewport);
        const horizontalInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= belowViewport);

        return verticalInView && horizontalInView;
    }

    /**
     * Возвращает передаваемую функцию не чаще, чем раз в wait мс
     * @param {Object} func - функция
     * @param {number} wait - время ожидания, мс
     * @returns {Function} - func
     */
    static debounce(func, wait) {
        /* eslint-disable */
        let timeout;

        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, wait);
        };
        /* eslint-enable */
    }

    /**
     * Клик по элементу или мимо
     *
     * @param {array} selectors - Строка или масив селектор(а)ов отслеживаемых елемент(а)ов
     * @param {function} outside - Callback если клик вне елемент(а)ов
     * @param {function} inside - Callback если клик по елемент(у)ам
     */
    static clickOutside(selectors, outside = function() {}, inside = function() {}) {
        if (!selectors) {
            return;
        }

        const elements = [];

        if (typeof selectors == 'string') {
            elements.push(Array.from(document.querySelectorAll(selectors)));
        } else {
            Array.from(selectors).forEach((selector) => {
                elements.push(Array.from(document.querySelectorAll(selector)));
            });
        }

        document.addEventListener('click', (event) => {
            let target = event.target;

            do {
                try {
                    // eslint-disable-next-line no-loop-func
                    elements.forEach((element) => {
                        if (element.indexOf(target) !== -1) {
                            inside();

                            // eslint-disable-next-line no-throw-literal
                            throw false;
                        }
                    });
                } catch (error) {
                    return;
                }

                target = target.parentNode;
            } while (target);

            outside();
        });
    }

    /**
     * Конвертирует число или строку в строку с рарядами.
     * @param {string/number} value - число или строка.
     * @return {string} - преобразованная строка.
     */
    static convertToDigit(value) {
        return Number(value).toLocaleString('ru-Ru');
    }

    /**
     * Метод конвертирует строку (можно с разрядами) в число
     * @param {string} str - необходимая строка.
     * @return {number} - сковертированное число.
     */
    static convertToNumber(str) {
        return parseFloat(str
            .toString()
            .replace(/\s/g, ''));
    }

    /**
     * Фиксирует страницу для запрета прокрутки
     * @param {Node} element - кроме данного элемента у всех остальных сбросится скролл
     */
    static bodyFixed(element) {
        disableBodyScroll(element, {reserveScrollBarGap: true});
        depthBodyFixed.push(element);
    }

    /**
     * Снимаем фиксирование страницы
     */
    static bodyStatic() {
        depthBodyFixed.splice(-1, 1);

        if (!depthBodyFixed.length) {
            clearAllBodyScrollLocks();
        }
    }

    /**
     * Возвращает булевое значение если текущий размер находится в интервале переданных брейкопинтов.
     * Например при 380 и переданных значениях (320 670) вернет true, во всех остальных случаях false.
     * @param {Number} min - минимальное значение ширины. Будет тру если больше или равно.
     * @param {Number} max - максимальное значение ширины. Будет тру если меньше.
     * @return {boolean} булевое значение если попадает в переданный интервал
     */
    static isBreakpoint(min, max) {
        return window.innerWidth >= min && window.innerWidth < max;
    }

    /**
     * кодирование строки Unicode в base-64
     * @param {String} str - Строка
     * @return {String} Закодированная строка в base64
     */
    static toBase64(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }

    /**
     * декодирование строки из base-64 в Unicode
     * @param {String} str - закодированная строка в base64
     * @returns {String} Декодированная строка
     */
    static fromBase64(str) {
        return decodeURIComponent(escape(window.atob(str)));
    }
}

export default Utils;
